// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_gatetype,
  add_gatetype,
  update_gatetype,
  delete_gatetype,
  get_gatetype_list
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  gatetypes: [],
  gatetypelist:[],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name:"",
    discription:"",
    checkout_time:"",
  },
  filterData: {
    school_class: "",
  },
};
// Async Thunks for API Calls
export const fetchgatetypelist = createAsyncThunk(
    'gatetypetype/fetchgatetypelist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_gatetype_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
// Async Thunks for API Calls
export const fetchgatetype = createAsyncThunk(
  "gatetype/fetchgatetype",
  async (
    { page, page_size, school_id,token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_gatetype(
        page,
        page_size,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const creategatetype = createAsyncThunk(
  "gatetype/creategatetype",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_gatetype(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updategatetype = createAsyncThunk(
  "gatetype/updategatetype",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_gatetype(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletegatetype = createAsyncThunk(
  "gatetype/deletegatetype",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_gatetype({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const gatetypeSlice = createSlice({
  name: "gatetypes",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
      EditFormData(reduxState, action) {
        reduxState.formData = { ...action.payload };
      },
    resetFormData(state) {
      state.formData = {
        name:"",
        discription:"",
        checkout_time:"",
      };
    },
    setgatetype(state, action) {
      state.gatetypes = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchgatetypelist.fulfilled, (state, action) => {
        state.gatetypelist = action.payload.data;
      })
      .addCase(fetchgatetypelist.rejected, (state, action) => {
        state.gatetypelist = [];

      })
   
      // Fetch Classes
      .addCase(fetchgatetype.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchgatetype.fulfilled, (state, action) => {
        state.loading = false;
        state.gatetypes = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchgatetype.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(creategatetype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(creategatetype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(creategatetype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updategatetype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updategatetype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updategatetype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete Class
      .addCase(deletegatetype.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletegatetype.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletegatetype.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setgatetype,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,

} = gatetypeSlice.actions;
export default gatetypeSlice.reducer;
